import {
  GET_AMEND_HUB_RECOMMENDATIONS_LOADING,
  GET_AMEND_HUB_RECOMMENDATIONS_LOADED,
  GET_AMEND_HUB_RECOMMENDATIONS_FAILED,
} from 'redux/modules/recommendations/actions/types';
import { deepFreeze } from 'utils/deepFreeze';

const initialState = deepFreeze({});

export default function recommendations(
  state = initialState,
  action: { result?: { [key: string]: unknown }; type: string; experience: string },
) {
  const { result = {}, type, experience } = action || {};

  switch (type) {
    case GET_AMEND_HUB_RECOMMENDATIONS_LOADING: {
      return {
        ...state,
        [experience]: { loading: true },
      };
    }
    case GET_AMEND_HUB_RECOMMENDATIONS_LOADED: {
      return {
        ...state,
        [experience]: { ...result, loading: false },
      };
    }
    case GET_AMEND_HUB_RECOMMENDATIONS_FAILED: {
      return {
        ...state,
        [experience]: { loading: false },
      };
    }
    default:
      return state;
  }
}
